import { render, staticRenderFns } from "./PromocodeShort.vue?vue&type=template&id=27597024&scoped=true&"
import script from "./PromocodeShort.vue?vue&type=script&lang=js&"
export * from "./PromocodeShort.vue?vue&type=script&lang=js&"
import style0 from "./PromocodeShort.vue?vue&type=style&index=0&id=27597024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27597024",
  null
  
)

export default component.exports